import { dataHooks } from '@wix/data-hooks'

export const wixStudioWelcomeSwitchDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  questionTitle: {}
  back: {}
  item: { key: string }
  link: {}
}>('wix-studio-welcome-switch')
